import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/** A month as one number (year * 12 + month - 1), the same key either service compares months by. */
export const monthKeyOf = (year, month) => year && month ? year * 12 + (month - 1) : null;

/** "2026-10-01" as a month key. */
export const monthKeyOfDate = date => {
  const _String$split$map = String(date || '').split('-').map(Number),
    _String$split$map2 = _slicedToArray(_String$split$map, 2),
    year = _String$split$map2[0],
    month = _String$split$map2[1];
  return monthKeyOf(year, month);
};

/**
 * Whether a service scheduled for `scheduledFor` still waits for its month (LB-6009): its month is after the month in
 * progress, or the month in progress isn't known, when only the month it is scheduled for can be said.
 */
export const isStillScheduled = (scheduledFor, monthInProgress) => {
  const scheduled = monthKeyOfDate(scheduledFor);
  if (scheduled === null) return false;
  return monthInProgress === null || monthInProgress === undefined || scheduled > monthInProgress;
};